module.exports = __webpack_public_path__ + "img/6.7291fd0d.gif";